import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';

import { formatMessage, setLanguage } from '@/locales';
import { LocalStorageService } from '@/services';
import LogoImage from './img/logo@2x.png';
import './footer.less';

export const Footer = () => {
    const history = useHistory();
    const { pathname } = useLocation();

    const localId = LocalStorageService.get('localId');
    const [local, setLocal] = useState('en-US');

    const setLanguageHandler = newLocalId => {
        setLocal(newLocalId);
        setLanguage(newLocalId);
        history.replace(pathname, {
            localId
        });

        LocalStorageService.set('localId', newLocalId);
    };

    useEffect(() => {
        if (localId && localId !== local) {
            setLocal(localId);
        }
    }, [local, localId]);

    return (
        <footer className="footer">
            <ul className="website-info-list">
                <li className="website-info-item">
                    <a className="logo-wrapper" to="/">
                        <img src={LogoImage} alt="" />
                    </a>
                </li>
                <li className="website-info-item">
                    <a href="/termsOfService.html" target="_blank">{formatMessage('footer.link.termsOfService')}</a>
                </li>
                <li className="website-info-item">
                    <a href="/privacyPolicy.html" target="_blank">{formatMessage('footer.link.privacyPolicy')}</a>
                </li>
                <li className="website-info-item">
                    <a href="mailto:public@dxx.cn" target="_blank">
                        {formatMessage('footer.link.support')}
                    </a>
                </li>
                <li className="website-info-item">
                    <a href="mailto:public@dxx.cn"  target="_blank">
                        {formatMessage('footer.link.contacts')}
                    </a>
                </li>
                <li className="website-info-item toggle-local">
                    <span
                        className={classNames({
                            active: local === 'en-US'
                        })}
                        onClick={() => {
                            setLanguageHandler('en-US');
                        }}
                    >
                        EN
                    </span>
                    <span>/</span>
                    <span
                        className={classNames({
                            active: local === 'zh-CN'
                        })}
                        onClick={() => {
                            setLanguageHandler('zh-CN');
                        }}
                    >
                        中文
                    </span>
                </li>
            </ul>
            
            <p className="copyright">{formatMessage('footer.copyright')  } <br/> <br/> {formatMessage('footer.relationship')}
            </p>
            {/* <p className="copyright"> <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备18026551号-1</a></p> */}
        </footer>
    );
};
